import { Popover } from "@jugl-web/ui-components/cross-platform/Popover";
import { Button } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import React from "react";
import { ReactComponent as AddIcon } from "./assets/add.svg";
import { VariableListSection } from "./components";
import { AutomationVariableListItem } from "./types";

type AutomationVariablesPopoverProps = {
  listItems: AutomationVariableListItem[];
  onInsert: (id: string) => void;
  triggerVariant?: "labeled" | "iconOnly";
};

export const AutomationVariablesPopover: React.FC<
  AutomationVariablesPopoverProps
> = ({ listItems, onInsert, triggerVariant = "labeled" }) => {
  const { t } = useTranslations();

  return (
    <Popover
      placement="bottom-end"
      className="jugl__custom-scrollbar max-h-[400px] w-[360px] overflow-y-auto p-1.5"
      renderTrigger={({ Trigger, triggerRef }) => (
        <Trigger
          ref={triggerRef}
          as={Button}
          variant="secondary"
          size="sm"
          iconEnd={triggerVariant !== "iconOnly" ? <AddIcon /> : undefined}
        >
          {triggerVariant !== "iconOnly" ? (
            t({
              id: "cx-actions-page.add-variable",
              defaultMessage: "Add Variable",
            })
          ) : (
            <div className="flex items-center justify-center">
              <AddIcon />
            </div>
          )}
        </Trigger>
      )}
    >
      {({ onClose }) =>
        listItems.length > 0 ? (
          <VariableListSection
            title={t({
              id: "cx-actions-page.input-variables",
              defaultMessage: "Input Variables",
            })}
            items={listItems}
            getDescription={(item) => item.value.description}
            onItemClick={(id) => {
              onInsert(id);
              onClose();
            }}
          />
        ) : (
          <div className="px-3 py-2 font-secondary text-sm text-dark-600">
            {t({
              id: "cx-actions-page.no-input-variables",
              defaultMessage: "Define a Data Input above to use it here",
            })}
          </div>
        )
      }
    </Popover>
  );
};
